import { effect, Injectable, Signal, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GuidedTourService {
  active: WritableSignal<boolean> = signal(false);
  readonly isActive: Signal<boolean> = this.active;

  toogle(): void {
    this.active.set(!this.active())
  }

  constructor() {
    // effect(() => console.log(this.active()))
  }
}